import { Component, TemplateRef, ViewChild, ViewEncapsulation } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ActivatedRoute, NavigationEnd, Router, RouterModule } from '@angular/router';
import { AuthService } from '../../../../../core/services/auth.service';
import { AppActionCheck } from '../../../../../core/utils/app-action-check';
import { GlobalName } from '../../../../../core/utils/global-name';
import { LocalStorageService } from '../../../../../core/utils/local-stoarge-service';
import { MenuAdminSys, MenuTEST } from './menu';
import {} from '@angular/common/http';
import { NgbOffcanvas } from '@ng-bootstrap/ng-bootstrap';

@Component({
    selector: 'app-menu',
    imports: [RouterModule],
    templateUrl: './menu.component.html',
    styleUrl: './menu.component.css',
    encapsulation: ViewEncapsulation.None
})
export class MenuComponent {
  @ViewChild('contentMenu') contentMenu:TemplateRef<any> | undefined
  menu:any[]=[]
  periods:any[]=[]
  permissions:any[]=[]
  windows:any[]=[]
  role:any
  user:any
  roles:any[]=[]
  cycles:any[]=[]
  currentRoleIndex=0;
  canReload=false
  currentRole:any

  constructor(
    private lsService:LocalStorageService,
    private authService:AuthService,
    private offcanvasService: NgbOffcanvas,
    private activatedRoute:ActivatedRoute,
    private router:Router,

  ) { }

  ngOnInit(): void {
    
    this.user=this.lsService.get(GlobalName.userName)
    this.roles=this.user.roles
    this.cycles=this.lsService.get(GlobalName.features).cycles

    // Tous les roles, adminsys compris, passent par le menu pilote par les
    // permissions : l'adminsys recevait auparavant MenuAdminSys, un menu
    // statique de cinq entrees, alors que l'API lui renvoie l'integralite des
    // fonctionnalites.
    this.activatedRoute.paramMap.subscribe((res:any)=>{
      // L'index de role est conserve d'une session a l'autre. S'il depasse le
      // nombre de roles du compte qui vient de se connecter, la lecture de
      // roles[index] echouait et le menu restait vide jusqu'au rechargement.
      const saved=this.lsService.get(GlobalName.currentRoleIndex)
      const index=saved!=null ? parseInt(saved) : 0
      this.currentRoleIndex = (!isNaN(index) && index>=0 && index<this.roles.length) ? index : 0
      this.currentRole=this.roles[this.currentRoleIndex]?.name
      this.loadMenu()
    })
 

  }

  loadMenu(){
    this.permissions=this.user.roles[this.currentRoleIndex]?.permissions;
    this.windows=(this.user.windows ?? []).filter((el:any)=> el.role_id== this.user.roles[this.currentRoleIndex]?.id);
     this.menu=this.reinitMenu();
    const isAdminSys=this.user.roles[this.currentRoleIndex]?.name=="adminsys";
    // console.log(this.menu);
    this.menu.forEach((el:any)=>{
      let majorStatus=false
      el.elements.forEach((el2:any)=>{
       if (el2.hasChildren) {
          el2.children.forEach((el3:any)=>{ 
            let check=this.windows.find((w:any)=>w.key==el3.key)
            let status= check!=undefined && AppActionCheck.check(el3.key,'list') && AppActionCheck.check(el3.key,'add')?true:false
            el3.status=status
            if(status){
              el2.status=status
              majorStatus=true
            }
          })
       } else {
        let check=this.windows.find((w:any)=>w.key==el2.key);
        let status= check!=undefined && AppActionCheck.check(el2.key,'list') && AppActionCheck.check(el2.key,'add')?true:false
        // Le suivi des acquis ne concerne que le primaire : il reste masque pour
        // le personnel hors de ces cycles, mais pas pour l'administrateur
        // systeme, qui doit pouvoir tout configurer au demarrage.
        let verifyCycle=(this.user?.cycles ?? []).filter((el:any)=> el.tag == this.cycles[0] || el.tag == this.cycles[1] || el.tag == this.cycles[2])

        if (!isAdminSys && verifyCycle.length ==0 && el2.key=="admin-followed-archievements") {
          el2.status=false
          status=false
        }else{
          el2.status=status
        
        }
        if(status){
          el2.status=status
          majorStatus=true
        }
       }
      })
      el.status=majorStatus
    })

    // Filet de securite sur une base neuve : sans fonctionnalite ni permission
    // en base, l'administrateur systeme garderait un menu vide et ne pourrait
    // plus rien configurer. On lui sert alors le menu de demarrage.
    if (isAdminSys && !this.menu.some((el:any)=>el.status)) {
      this.menu=MenuAdminSys
    }

    if(this.canReload) window.location.reload()
  }

  reinitMenu(){
    let menu =MenuTEST;
    this.menu.forEach((el:any,index:any)=>{
      el.elements.forEach((el2:any,index2:any)=>{
       if (el2.hasChildren) {
          el2.children.forEach((el3:any,index3:any)=>{ 
            this.menu[index].elements[index2].children[index3].status=false
          })
       } else {
        this.menu[index].elements[index2].status=false
       }
      })
      this.menu[index].status=false
    })

    return menu;
  }
 
  changeRole(ev:any){
    this.currentRoleIndex=this.roles.findIndex((el:any)=>el.name == ev.target.value)
    this.lsService.set(GlobalName.currentRoleIndex,this.currentRoleIndex.toString());
    this.canReload=true
    this.loadMenu();
    
  }


  /**
   * Un groupe replie ne donnait aucune indication lorsqu'une de ses pages
   * etait ouverte : le groupe reste desormais deplie et mis en evidence.
   */
  isGroupActive(e:any){
    const url=this.router.url.split('?')[0]
    return (e?.children ?? []).some((c:any)=> c?.route && (url===c.route || url.startsWith(c.route+'/')))
  }

  openMenu(){
    this.offcanvasService.open(this.contentMenu,{  panelClass: 'details-panel',position:'end'});
  }
  closeMenu(){
    let closeMenuBtn:HTMLElement = document.getElementById('closeMenuBtn') as HTMLElement;
    closeMenuBtn?.click()

  }

}
